// extracted by mini-css-extract-plugin
export default {"progress":"ValueProgress_progress__NRde0"};